import * as React from 'react';
const { ButtonGroup } = require('@cvent/carina-button-group');
const { ThemeProvider } = require('@cvent/carina-theme-provider');
import wsCarinaTheme from '../../configs/carina-theme';
const controlStyles = require('./MapControl.scss');

interface Props {
    onChange: (mapType: google.maps.MapTypeId) => void;
}

// NOTE: not in use right now. Was implemented and then removed from design.
export default function MapTypeControl(props: Props) {
    const ROADMAP = google.maps.MapTypeId.ROADMAP;
    const SATELLITE = google.maps.MapTypeId.HYBRID;
    const [mode, setMode] = React.useState<google.maps.MapTypeId>(ROADMAP);

    return (
        <ThemeProvider theme={wsCarinaTheme}>
            <div className={controlStyles.mapControls} style={{ padding: 16 }}>
                <ButtonGroup
                    onChange={(idx: number) => {
                        if (idx !== null) {
                            let newMode = idx === 0 ? ROADMAP : SATELLITE;
                            setMode(newMode);
                            props.onChange(newMode);
                        }
                    }}
                    size='m'
                    selected={mode === ROADMAP ? 0 : 1}
                >
                    <ButtonGroup.Item text='Map' />
                    <ButtonGroup.Item text='Satellite' />
                </ButtonGroup>
            </div>
        </ThemeProvider>
    );
}
